// Vite exposes env vars as import.meta.env and only those prefixed VITE_ --
// the Next equivalent was process.env.NEXT_PUBLIC_*. Same inlining caveat
// applies as before: these are baked into the bundle at BUILD time, not read
// at runtime, so changing the API URL means rebuilding, not restarting.
// With nothing set, the portal calls whatever origin it was loaded from. That is
// what makes the single-port setup work: the backend serves this portal AND the
// API on one port (e.g. 8301), and IIS does the same on the public URL.
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || window.location.origin;

// Defaults to OpenStreetMap's public tile server, which is fine for dev but
// not licensed for sustained production traffic. Set VITE_BASEMAP_TILE_URL
// to a real provider (MapTiler, Stadia Maps, self-hosted) before launch --
// swapping it is a .env change instead of a code change.
export const BASEMAP_TILE_URL =
  import.meta.env.VITE_BASEMAP_TILE_URL || "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
export const BASEMAP_ATTRIBUTION =
  import.meta.env.VITE_BASEMAP_ATTRIBUTION || "© OpenStreetMap contributors";

// The map's "Satellite map" switch. Google's satellite tiles by default -- the
// same ones the field app uses -- spread over its four tile hosts so they load
// in parallel. These URLs are not Google's licensed Map Tiles API; set
// VITE_SATELLITE_TILE_URL to a licensed source to swap them without a code change.
export const SATELLITE_TILE_URLS: string[] = import.meta.env.VITE_SATELLITE_TILE_URL
  ? [import.meta.env.VITE_SATELLITE_TILE_URL]
  : [0, 1, 2, 3].map((n) => `https://mt${n}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}`);
export const SATELLITE_ATTRIBUTION =
  import.meta.env.VITE_SATELLITE_ATTRIBUTION || "Imagery © Google";
